import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.23.1_next@14.2.20_@babel+core@7.25.8_@opentelemetry+api@1.9.0_@playwright+t_c643c35ddbe6f04ed73c482f138f9b93/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.23.1_next@14.2.20_@babel+core@7.25.8_@opentelemetry+api@1.9.0_@playwright+t_c643c35ddbe6f04ed73c482f138f9b93/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.20_@babel+core@7.25.8_@opentelemetry+api@1.9.0_@playwright+test@1.51.1_react-_af630688e18c61debfeba8add5f2211f/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookingButtons"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/booking/BookingButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BookingPhones"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/booking/BookingPhones.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DoctorBookingOnline"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/booking/DoctorBookingOnline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DoctorBottomBar"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/doctorBottomBar/DoctorBottomBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DoctorNavbar"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/DoctorNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DoctorPriceWrapper"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/DoctorPriceWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MedcenterTabsClient"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/medcenterTabs/MedcenterTabsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneDialogWrapper"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/PhoneDialogWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecommendationListClient"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/recommendations/RecommendationListClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServicesListClient"] */ "/app/src/app/[locale]/[city]/doctor/[alias]/ui/services/ServicesListClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMContext"] */ "/app/src/features/Analytics/model/context/GTMContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["GTMInitializer"] */ "/app/src/features/Analytics/ui/GTMInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMProvider"] */ "/app/src/features/Analytics/ui/GTMProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/sprites/doctor.sprite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/sprites/social.sprite.svg");
;
import(/* webpackMode: "eager", webpackExports: ["TrackEvent"] */ "/app/src/shared/lib/analytics/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionLinks"] */ "/app/src/widgets/MainLayout/ui/footer/SectionLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/MainLayout/ui/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewsListClient"] */ "/app/src/widgets/Reviews/ui/ReviewsListClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitleSection"] */ "/app/src/widgets/TitleSection/ui/index.tsx");
